export default [
  {
    id: 1,
    name: 'Mr.',
    label: 'Mr.',
    value: 'mr',
  },
  {
    id: 2,
    name: 'Ms.',
    label: 'Ms.',
    value: 'ms',
  },
  {
    id: 3,
    name: 'Mrs.',
    label: 'Mrs.',
    value: 'mrs',
  },
];
